export enum SessionStatus {
  initial = 'initial',
  fulfilled = 'fulfilled',
  logOut = 'logOut',
}
